import React from "react";
import {Button} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import './Overlay.css';

interface Image {
    source: string;
    filename: string;
    x: number;
    y: number;
    imageUrl: string;
}

interface OverlayProps {
    selectedImage: Image;
    clickedImage: Image | null;
    closestImages: Image[];
    panelIndex: number;
    useHeatmaps: boolean;
    selectedOptions: string[];
    handleClosePanel: (event: React.MouseEvent<HTMLDivElement>) => void;
    handlePrevious: () => void;
    handleNext: () => void;
    handleClosestImageClick: (image: Image) => void;
}

const Overlay: React.FC<OverlayProps> = ({
                                             selectedImage,
                                             clickedImage,
                                             closestImages,
                                             panelIndex,
                                             useHeatmaps,
                                             selectedOptions,
                                             handleClosePanel,
                                             handlePrevious,
                                             handleNext,
                                             handleClosestImageClick
                                         }) => (
    <div className="panel-overlay" onClick={handleClosePanel}>
        <div className="panel-content">
            <div className="panel-content-upper">
                <div className="overlay-image-frame">
                    <img
                        src={useHeatmaps ? selectedImage.imageUrl.replace("apn/", "").replace(`${selectedOptions[0].toLowerCase()}/`, '')
                            .replace('images', `heatmaps/${selectedOptions[0].toLowerCase()}/${selectedOptions[2]}/${selectedOptions[3].replace(' ', '')}/`) : selectedImage.imageUrl}
                        alt="Selected" className="panel-selected-image"/>
                </div>
                {clickedImage ? (
                    <div className="overlay-image-frame">
                        <img
                            src={useHeatmaps ? clickedImage.imageUrl.replace("apn/", "").replace(`${selectedOptions[0].toLowerCase()}/`, '')
                                .replace('images', `heatmaps/${selectedOptions[0].toLowerCase()}/${selectedOptions[2]}/${selectedOptions[3].replace(' ', '')}/`) : clickedImage.imageUrl}
                            alt="Clicked Similar" className="panel-selected-image"/>
                    </div>
                ) : (
                    <div className="overlay-image-frame placeholder-area">
                        <span>No image selected</span>
                    </div>
                )}
            </div>
            <div className="panel-divider"></div>
            <div className="panel-content-lower">
                <Button className="panel-button-left" variant="contained" style={{backgroundColor: '#ccc'}}
                        onClick={handlePrevious}>
                    <ArrowBackIcon/>
                </Button>
                {closestImages.slice(panelIndex, panelIndex + 5).length > 0 ? (
                    closestImages.slice(panelIndex, panelIndex + 5).map((image, index) => (
                        <div key={index} className="panel-placeholder-area">
                            <img
                                src={useHeatmaps ? image.imageUrl.replace("apn/", "").replace(`${selectedOptions[0].toLowerCase()}/`, '')
                                    .replace('images', `heatmaps/${selectedOptions[0].toLowerCase()}/${selectedOptions[2]}/${selectedOptions[3].replace(' ', '')}/`) : image.imageUrl}
                                alt={`Similar ${index + 1}`} className="similar-image"
                                onClick={() => handleClosestImageClick(image)}
                            />
                        </div>
                    ))
                ) : (
                    <>
                        <div className="no-image-selected-similar">No image selected</div>
                        <div className="no-image-selected-similar">No image selected</div>
                    </>
                )}
                <Button className="panel-button-right" variant="contained" style={{backgroundColor: '#ccc'}}
                        onClick={handleNext}>
                    <ArrowForwardIcon/>
                </Button>
            </div>
        </div>
    </div>
);

export default Overlay;